var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 7H33C33.663 7 34.2989 7.26339 34.7678 7.73223C35.2366 8.20107 35.5 8.83696 35.5 9.5V29.5C35.5 30.163 35.2366 30.7989 34.7678 31.2678C34.2989 31.7366 33.663 32 33 32H3C2.33696 32 1.70107 31.7366 1.23223 31.2678C0.763392 30.7989 0.5 30.163 0.5 29.5V3.25C0.5 2.58696 0.763392 1.95107 1.23223 1.48223C1.70107 1.01339 2.33696 0.75 3 0.75H30.5V3.25H3V7ZM3 9.5V29.5H33V25.75H23C22.337 25.75 21.7011 25.4866 21.2322 25.0178C20.7634 24.5489 20.5 23.913 20.5 23.25V15.75C20.5 15.087 20.7634 14.4511 21.2322 13.9822C21.7011 13.5134 22.337 13.25 23 13.25H33V9.5H3ZM33 23.25V15.75H23V23.25H33ZM25.5 18.25H28V20.75H25.5V18.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/WalletIcon.73bacdcdf6e5f784e93ef0138e6f6ee7.svg";
export { ForwardRef as ReactComponent };